import {useCallback, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Payment from "./payment";
import {setWorkspaceGraphPayments, upsertWorkspacePayment, workspaceGraphSelectors} from "../../system/workspace-graph-slice";
import {normalizeMembershipEntity} from "../workspace-membership/workspace-membership-identity";

const paymentPopulate = {
    workspace: true,
    payer: {populate: {member: {populate: {profileImage: true}}}},
    order: true,
    invoice: true,
};

export function usePayment() {
    const dispatch = useDispatch();
    const payments = useSelector(workspaceGraphSelectors.payments);
    const workspaceMembership = useSelector((state) => state.app?.workspaceMembershipData);
    const memberships = useMemo(
        () => workspaceMembership?.workspace?.workspace_memberships || [],
        [workspaceMembership],
    );
    const [zarinpalLoading, setZarinpalLoading] = useState(false);

    const getPayments = useCallback(async (workspaceId) => {
        if (!workspaceId) return [];
        const model = new Payment();
        const response = await model.getAll({
            populate: paymentPopulate,
            sort: ["createdAt:desc"],
            pagination: {pageSize: 20},
        });
        const items = (response?.data || []).map((item) =>
            normalizeMembershipEntity(item, "payment", memberships));
        dispatch(setWorkspaceGraphPayments(items));
        return items;
    }, [dispatch, memberships]);

    const getPayment = useCallback(async (documentId) => {
        const model = new Payment();
        const response = await model.getById(documentId, {populate: paymentPopulate});
        const item = normalizeMembershipEntity(response?.data, "payment", memberships);
        if (item) dispatch(upsertWorkspacePayment(item));
        return item || null;
    }, [dispatch, memberships]);

    const requestZarinpalPayment = useCallback(async (paymentDocumentId) => {
        const model = new Payment();
        setZarinpalLoading(true);
        try {
            const response = await model.requestZarinpal(paymentDocumentId);
            return response?.data || null;
        } finally {
            setZarinpalLoading(false);
        }
    }, []);

    const payInvoice = useCallback(async (invoiceDocumentId) => {
        const model = new Payment();
        setZarinpalLoading(true);
        try {
            const response = await model.requestZarinpalForInvoice(invoiceDocumentId);
            return response?.data || null;
        } finally {
            setZarinpalLoading(false);
        }
    }, []);

    const getZarinpalPaymentStatus = useCallback(async (authority, workspaceDocumentId) => {
        const model = new Payment();
        const response = await model.getZarinpalStatus(authority, workspaceDocumentId);
        return response?.data || null;
    }, []);

    return {
        payments,
        getPayments,
        getPayment,
        requestZarinpalPayment,
        payInvoice,
        getZarinpalPaymentStatus,
        zarinpalLoading,
    };
}
